// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__moCoW","col":"styles_col__1R9Uf"};